import { UserIcon } from '@heroicons/react/20/solid';

// eslint-disable-next-line import/prefer-default-export
export const profileNavigation = [
  { name: 'My Profile', to: '/profile', icon: UserIcon },
];
